import { Emit, Inject, Options, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import { TrustAPI } from "@/shared/modules/trust-api";
import { AppInsights } from "@/trust-atcs-app/appInsights";
import { EventEmitter } from "events";
import store from "@/trust-atcs-app/store";
import FormatDateTimeMixin from '@/shared/mixins/format-datetime';
import LoadingSpinner from "@/shared/components/loading-spinner/index.vue";
import { FormPartBData } from "@/trust-atcs-app/models/form-part-b-data";
import RadioButtonHorizontal from "../questions/radiobutton-horizontal/index.vue";
import RadioButtonVertical from "../questions/radiobutton-vertical/index.vue";
import RadioButtonBranchList from "../questions/radiobutton-branchlist/index.vue";
import RadioButtonSubQuestions from "../questions/radiobutton-subquestions/index.vue";
import { ComplianceForm, PartBFormControlledMoney } from "@/shared/modules/typescript-trustapi-client/models";
import InputTextNumberCurrency from "../questions/input-text-number-currency/index.vue";
import FileUploader from "../questions/file-uploader/index.vue";

@Options({
  components: {
    LoadingSpinner,
    RadioButtonVertical,
    RadioButtonHorizontal,
    RadioButtonBranchList,
    RadioButtonSubQuestions,
    InputTextNumberCurrency,
    FileUploader,
  },
  mixins: [FormatDateTimeMixin],
})
export default class FormPartBControlledMoney extends Vue {

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  @Prop({ default: false })
  private isSectionLoading!: boolean;

  @Prop()
  private formPartBData!: FormPartBData;

  @Emit('update:isSectionLoading')
  @Emit('validForm')

  @Watch('loadingContent')
  private sectionLoading() {
    this.$emit('update:isSectionLoading', this.loadingContent);
  }

  @Ref('fileDropAndDrop') readonly fileDropAndDrop!: any;

  private ai = new AppInsights;
  private loadingContent = false;
  private errorLoadingContent = false;

  private validMainQuestions: boolean[] = [];
  private controlledMoney: PartBFormControlledMoney = null as any;

  private uploading = false;
  private fileLists: any[] = [];

  mounted(): void {
    this.eventCtrl.on('reload-form-b-cm-content', this.loadControlledMoneyContent);
    this.loadControlledMoneyContent();
  }

  beforeUnmount(): void {
    this.eventCtrl.removeListener('reload-form-b-cm-content', this.loadControlledMoneyContent);
  }

  private async loadControlledMoneyContent(): Promise<void> {
    try {
      this.loadingContent = true;
      const resp: any = await this.apiService.PartBFormApi?.apiV2PartBFormGetControlledMoneyPost({
        complianceFormId: this.complianceFormB.id,
        updatingKey: this.updatingKey,
        manageSignatoryUpdatingKey: this.signatoriesUpdatingKey
      });
      this.controlledMoney = resp.data.data as PartBFormControlledMoney;
      this.formPartBData.controlledMoney = this.controlledMoney as any;

      // Sort atcsMainQuestions by order number
      this.formPartBData.controlledMoney.atcsMainQuestions = this.formPartBData.controlledMoney.atcsMainQuestions.sort((a: any, b: any) => a.order - b.order);
      // Sort atcsSubQuestions by order number
      this.formPartBData.controlledMoney.atcsMainQuestions.forEach((q: any) => {
        q.atcsSubQuestions = q.atcsSubQuestions.sort((a: any, b: any) => a.order - b.order);
      });
      // Sort response by order number
      this.formPartBData.controlledMoney.atcsMainQuestions.forEach((q: any) => {
        q.responses = q.responses.sort((a: any, b: any) => a.order - b.order);
      });

      this.validMainQuestions = this.formPartBData.controlledMoney.atcsMainQuestions.map((q: any) => false);

      // Fill File Lists
      this.fileLists = [];
      this.formPartBData.controlledMoney.atcsMainQuestions.forEach((x: any, i: number) => {
        if (x.atcsQuestionTypeId == 8) {
          this.fileLists[i] = [];
        }
      });

    } catch (err) {
      this.eventCtrl.emit('show-snackbar', 'error', 'Error getting General Trust Money');
      this.ai.trackException('Error getting General Trust Money: ' + err);
      this.errorLoadingContent = true;
      console.log(err);
    } finally {
      this.loadingContent = false;
    }
  }

  private validForm(): boolean {
    return !this.validMainQuestions.includes(false);
  }

  private validationForm(i: any, isValid: any) {
    this.validMainQuestions[i] = isValid;
    this.$emit('validForm', this.validForm());
  }

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

  get complianceFormB(): ComplianceForm {
    return store.getters.getSelectedComplianceFormB;
  }

  get updatingKey(): string {
    return store.getters.getFormUpdatingKey;
  }

  get signatoriesPracticeCoreId(): number | null {
    return store.getters.getSelectedPracticeCoreId;
  }

  get signatoriesUpdatingKey(): string {
    return store.getters.getSignatoriesUpdatingKey;
  }
}

